import React from 'react';
const stats: [string, string][] = [['6', 'Premium Volumes'], ['390+', 'Total Pages'], ['78', 'Tarot Cards Decoded'], ['50+', 'Reference Charts'], ['5', 'Bonus Guides Free']];
export function StatsBar() {
  return <section className="w-full bg-surface px-4 py-10 sm:py-12" data-id="element-215" data-mp="1oac8poepkv63">
      <div className="mx-auto grid max-w-6xl grid-cols-2 gap-y-8 text-center sm:grid-cols-3 lg:grid-cols-5" data-id="element-216" data-mp="1jcapn3ha8vum">
        {stats.map(([value, label]) => <div key={label} data-id="element-217" data-mp="1ee950e47koh1">
            <div className="font-serif text-4xl text-amber" data-id="element-218" data-mp="1eeiqboeb67ge">{value}</div>
            <div className="mt-1 text-[10px] font-bold uppercase tracking-[0.13em] text-navy/70 sm:text-xs" data-id="element-219" data-mp="19lpj8tvdan15">
              {label}
            </div>
          </div>)}
      </div>
    </section>;
}